import type { ChargingProfileSnapshot } from '@/domain';
import type { ChargingProfileId, StationId } from '@/domain/types';
import type { ChargingProfileRepository } from '@/persistence/ports';
import type { Evse3Database } from '../db';

export class ChargingProfileRepositoryDexie implements ChargingProfileRepository {
  constructor(private readonly db: Evse3Database) {}

  async byStation(stationId: StationId): Promise<readonly ChargingProfileSnapshot[]> {
    const rows = await this.db.chargingProfiles.where('stationId').equals(stationId).toArray();
    return rows.map(({ stationId: _s, ...rest }) => rest);
  }

  async upsert(stationId: StationId, snap: ChargingProfileSnapshot): Promise<void> {
    await this.db.chargingProfiles.put({ stationId, ...snap });
  }

  async delete(stationId: StationId, id: ChargingProfileId): Promise<void> {
    await this.db.chargingProfiles.delete([stationId, id]);
  }

  async clear(stationId: StationId): Promise<void> {
    await this.db.chargingProfiles.where('stationId').equals(stationId).delete();
  }
}
